define('OutSystems/ClientRuntime/Entities',["require", "exports", "./Database", "./DataConversion", "./DataTypes", "./Exceptions", "./Interfaces", "./Logger", "./RegExpHelper"], function (require, exports, Database_1, DataConversion_1, DataTypes, Exceptions_1, Interfaces_1, Logger, RegExpHelper) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.QueryArgumentsList = exports.Entity = exports.webSQLStorageInstance = exports.WebSQLStorage = exports.Upgrades = exports.PersistentKeyValue = exports.LogTable = exports.BACKUP_TABLE_PREFIX = void 0;
    exports.BACKUP_TABLE_PREFIX = "BACKUP_";
    function ignoreResult(arg) { }
    function extractScalar(dbRecord) {
        for (var key in dbRecord) {
            if (dbRecord.hasOwnProperty(key)) {
                return dbRecord[key];
            }
        }
        return null;
    }
    var LogTable;
    (function (LogTable) {
        var LOG_FIELDS = {
            Instant: "Instant",
            LogType: "LogType",
            Message: "Message",
            ModuleName: "ModuleName",
            Stack: "Stack",
            MessageType: "MessageType",
            ExtraInfo: "ExtraInfo",
        };
        LogTable.TABLE_NAME = "OSSYS_LOG";
        var maxRecords = 1000;
        var fieldNames = Object.keys(LOG_FIELDS).map(function (key) { return LOG_FIELDS[key]; });
        function createSql() {
            return "CREATE TABLE IF NOT EXISTS \"" + LogTable.TABLE_NAME + "\" (\"" + fieldNames.join("\",\"") + "\")";
        }
        LogTable.createSql = createSql;
        function addExtraInfoColumnIfNeeded(runner) {
            return runner
                .executeScalar("SELECT \"" + LogTable.TABLE_NAME + "\".\"" + LOG_FIELDS.ExtraInfo + "\" FROM \"" + LogTable.TABLE_NAME + "\" LIMIT 0")
                .onError(function () { return runner.executeNonQuery("ALTER TABLE \"" + LogTable.TABLE_NAME + "\" ADD \"" + LOG_FIELDS.ExtraInfo + "\""); })
                .andThen(function () {
            });
        }
        function setMaxRecords(newMax) {
            maxRecords = newMax;
        }
        LogTable.setMaxRecords = setMaxRecords;
        function initialize(runner, database) {
            return runner
                .executeNonQuery(createSql())
                .andThen(addExtraInfoColumnIfNeeded)
                .andThen(function (nextRunner) {
                var logStorage = new LogDatabaseStorage(database);
                return logStorage.initialize(nextRunner).andThen(function () { return Logger.setOfflineStorage(logStorage); });
            });
        }
        LogTable.initialize = initialize;
        var LogDatabaseStorage = (function () {
            function LogDatabaseStorage(db) {
                this.db = db;
            }
            LogDatabaseStorage.prototype.initialize = function (runner) {
                var _this = this;
                return runner.feed(null).withoutTraces(function (runner) {
                    return _this.internalCountLogs(runner).andThen(function (runner, count) {
                        _this.count = count;
                    });
                });
            };
            LogDatabaseStorage.prototype.insertEntity = function (runner, logMessage) {
                var _this = this;
                var insertArgList = new QueryArgumentsList();
                insertArgList.add(LOG_FIELDS.Instant, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.instant);
                insertArgList.add(LOG_FIELDS.LogType, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.logType);
                insertArgList.add(LOG_FIELDS.Message, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.message);
                insertArgList.add(LOG_FIELDS.ModuleName, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.moduleName);
                insertArgList.add(LOG_FIELDS.Stack, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.stack);
                insertArgList.add(LOG_FIELDS.MessageType, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.messageType);
                insertArgList.add(LOG_FIELDS.ExtraInfo, Interfaces_1.ClientDB.DBDataType.TEXT, logMessage.extra ? JSON.stringify(logMessage.extra) : null);
                return runner
                    .executeNonQuery("INSERT INTO \"" + LogTable.TABLE_NAME + "\" (\"" + fieldNames.join("\", \"") + "\") VALUES (" + fieldNames
                    .map(function () { return "?"; })
                    .join(", ") + ")", insertArgList.toArray())
                    .andThen(function () {
                    _this.updateCount(1);
                });
            };
            LogDatabaseStorage.prototype.internalWriteLog = function (logMessages) {
                var _this = this;
                return this.db.executeTransaction(function (runner) {
                    var promise;
                    if (_this.count + logMessages.length >= maxRecords) {
                        var numberLogsToDiscard = _this.count + logMessages.length - maxRecords;
                        promise = _this.discardLogs(runner, _this.count, numberLogsToDiscard);
                    }
                    else {
                        promise = runner.feed(null);
                    }
                    return promise.andThenAll(function (result) {
                        return logMessages.map(function (log) { return function (runner) { return _this.insertEntity(runner, log); }; });
                    });
                }, false);
            };
            LogDatabaseStorage.prototype.writeLog = function (logMessage) {
                return this.internalWriteLog([logMessage]);
            };
            LogDatabaseStorage.prototype.writeLogBatch = function (logBatch) {
                if (logBatch.length > maxRecords) {
                    var logsToDiscard = logBatch.length - maxRecords;
                    logBatch.splice(0, logsToDiscard);
                }
                return this.internalWriteLog(logBatch);
            };
            LogDatabaseStorage.prototype.getLogs = function (numberRows) {
                var _this = this;
                return this.db.executeReadTransaction(function (runner) {
                    if (numberRows === undefined) {
                        numberRows = _this.count;
                    }
                    return runner.executeQuery("SELECT * FROM \"" + LogTable.TABLE_NAME + "\" ORDER BY rowid ASC LIMIT " + numberRows, _this.dbRecordToLogMessage);
                }, false);
            };
            LogDatabaseStorage.prototype.popLogs = function (numberLogs) {
                var _this = this;
                if (numberLogs === undefined) {
                    numberLogs = this.count;
                }
                return this.getLogs(numberLogs).then(function (retrievedLogs) {
                    return _this.removeLogs(numberLogs).then(function () {
                        return retrievedLogs;
                    });
                });
            };
            LogDatabaseStorage.prototype.internalCountLogs = function (runner) {
                return runner
                    .executeScalar("SELECT COUNT(*) AS count FROM \"" + LogTable.TABLE_NAME + "\"")
                    .andThen(function (runner, result) { return result; });
            };
            LogDatabaseStorage.prototype.updateCount = function (change) {
                this.count += change;
                this.count = Math.max(this.count, 0);
            };
            LogDatabaseStorage.prototype.countLogs = function () {
                var _this = this;
                return this.db.executeReadTransaction(function (runner) {
                    return _this.internalCountLogs(runner);
                }, false);
            };
            LogDatabaseStorage.prototype.discardLogs = function (runner, initialCount, totalRowsToDelete) {
                var _this = this;
                var deleteQuery = this.buildDeleteQuery(totalRowsToDelete, false);
                return runner
                    .executeNonQuery(deleteQuery, [Logger.LogTypes.Error])
                    .andThen(function (runner) { return _this.internalCountLogs(runner); })
                    .andThen(function (runner, currentCount) {
                    var rowsDeleted = initialCount - currentCount;
                    if (rowsDeleted < totalRowsToDelete) {
                        var numberErrorsToDiscard = totalRowsToDelete - rowsDeleted;
                        deleteQuery = _this.buildDeleteQuery(numberErrorsToDiscard, true);
                        runner.executeNonQuery(deleteQuery, [Logger.LogTypes.Error]);
                    }
                })
                    .andThen(function () {
                    _this.updateCount(-totalRowsToDelete);
                });
            };
            LogDatabaseStorage.prototype.buildDeleteQuery = function (numberRowsToDelete, equalsLogType) {
                return ("DELETE FROM \"" + LogTable.TABLE_NAME + "\" " +
                    "WHERE rowid IN " +
                    ("(SELECT rowid FROM \"" + LogTable.TABLE_NAME + "\" ") +
                    ("WHERE LogType " + (equalsLogType ? "=" : "<>") + " ? ") +
                    "ORDER BY rowid ASC " +
                    ("LIMIT " + numberRowsToDelete + ")"));
            };
            LogDatabaseStorage.prototype.removeLogs = function (numberRowsToDelete) {
                var _this = this;
                return this.db.executeTransaction(function (runner) {
                    var deleteQuery = "DELETE FROM \"" + LogTable.TABLE_NAME + "\" WHERE rowid IN (SELECT rowid FROM \"" + LogTable.TABLE_NAME + "\" ORDER BY rowid ASC LIMIT " + numberRowsToDelete + ")";
                    return runner.executeNonQuery(deleteQuery).andThen(function () {
                        _this.updateCount(-numberRowsToDelete);
                    });
                }, false);
            };
            LogDatabaseStorage.prototype.dbRecordToLogMessage = function (dbRecord) {
                return {
                    instant: dbRecord.Instant,
                    logType: dbRecord.LogType,
                    message: dbRecord.Message,
                    moduleName: dbRecord.ModuleName,
                    stack: dbRecord.Stack,
                    messageType: dbRecord.MessageType,
                    extra: dbRecord.ExtraInfo ? JSON.parse(dbRecord.ExtraInfo) : undefined,
                };
            };
            return LogDatabaseStorage;
        }());
        LogTable.LogDatabaseStorage = LogDatabaseStorage;
    })(LogTable = exports.LogTable || (exports.LogTable = {}));
    var UpgradeStatus;
    (function (UpgradeStatus) {
        UpgradeStatus[UpgradeStatus["Unchanged"] = 0] = "Unchanged";
        UpgradeStatus[UpgradeStatus["Deleted"] = 1] = "Deleted";
        UpgradeStatus[UpgradeStatus["Recreated"] = 2] = "Recreated";
        UpgradeStatus[UpgradeStatus["New"] = 3] = "New";
    })(UpgradeStatus || (UpgradeStatus = {}));
    var PersistentKeyValue;
    (function (PersistentKeyValue) {
        var FIELDS = [
            { columnName: "Id", options: "INTEGER PRIMARY KEY AUTOINCREMENT NOT NULL" },
            { columnName: "Key", options: "UNIQUE NOT NULL" },
            { columnName: "Value" },
        ];
        PersistentKeyValue.TABLE_NAME = "OSSYS_PERSISTENTKEYVALUE";
        var FIELD_LIST = "\"" + FIELDS.map(function (f) { return f.columnName; }).join("\", \"") + "\"";
        var FIELD_WITH_OPTIONS = FIELDS.map(function (f) { return "'" + f.columnName + (!!f.options ? "' " + f.options : "'"); }).join(", ");
        function initialize(runner, db) {
            PersistentKeyValue.storage = new PersistentKeyValueStorage(db);
            return create(runner);
        }
        PersistentKeyValue.initialize = initialize;
        function create(runner) {
            return runner.executeNonQuery("CREATE TABLE IF NOT EXISTS \"" + PersistentKeyValue.TABLE_NAME + "\" (" + FIELD_WITH_OPTIONS + ")");
        }
        PersistentKeyValue.create = create;
        var PersistentKeyValueStorage = (function () {
            function PersistentKeyValueStorage(db) {
                this.db = db;
            }
            PersistentKeyValueStorage.prototype.isReady = function () {
                return Promise.resolve(true);
            };
            PersistentKeyValueStorage.prototype.getValue = function (key) {
                return this.db.executeTransaction(function (runner) {
                    return runner.executeScalar("SELECT VALUE FROM " + PersistentKeyValue.TABLE_NAME + " WHERE Key = ?", [key]);
                });
            };
            PersistentKeyValueStorage.prototype.setValue = function (key, value) {
                return this.db.executeTransaction(function (runner) {
                    return runner.executeNonQuery("INSERT OR REPLACE INTO " + PersistentKeyValue.TABLE_NAME + " (" + FIELD_LIST + ") VALUES (COALESCE((SELECT Id FROM " + PersistentKeyValue.TABLE_NAME + " WHERE Key = ?), null), ?, ?)", [key, key, value]);
                });
            };
            return PersistentKeyValueStorage;
        }());
        PersistentKeyValue.PersistentKeyValueStorage = PersistentKeyValueStorage;
    })(PersistentKeyValue = exports.PersistentKeyValue || (exports.PersistentKeyValue = {}));
    var Upgrades;
    (function (Upgrades) {
        function fillWithDefaults(dbRecordInLowercase, info) {
            for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
                var expectedAttr = _a[_i];
                var attrNameLower = expectedAttr.name.toLowerCase();
                if (dbRecordInLowercase[attrNameLower] === undefined) {
                    var defaultValue = expectedAttr.default === undefined
                        ? DataConversion_1.LocalStorageConverter.typeDefaultValue(expectedAttr.type)
                        : expectedAttr.default;
                    dbRecordInLowercase[attrNameLower] = DataConversion_1.LocalStorageConverter.serializeToDB(defaultValue, expectedAttr);
                }
            }
        }
        var Metamodel;
        (function (Metamodel) {
            var METADATA_TABLE_NAME = "OSSYS_ENTITY";
            var METADATA_BACKUP_TABLE_NAME = "" + exports.BACKUP_TABLE_PREFIX + METADATA_TABLE_NAME;
            var METADATA_FIELD_INFO = [
                { name: "SS_Key" },
                { name: "Module_SS_Key" },
                { name: "Name" },
                { name: "Physical_Table_name" },
                { name: "Hash" },
                { name: "Extra_Info", defaultValue: "'{\"attrs\":{}}'" },
                { name: "Upgrade_Status", defaultValue: 0..toString() },
            ];
            var METADATA_FIELD_LIST = "\"" + METADATA_FIELD_INFO.map(function (f) { return f.name; }).join("\", \"") + "\"";
            function getDefaultMetaData() {
                return {
                    v: -1,
                    attrs: {},
                };
            }
            Metamodel.getDefaultMetaData = getDefaultMetaData;
            function create(runner) {
                return innerCreate(runner, METADATA_TABLE_NAME).andThen(function (runner) {
                    return innerCreate(runner, "" + exports.BACKUP_TABLE_PREFIX + METADATA_TABLE_NAME);
                });
            }
            Metamodel.create = create;
            function innerCreate(runner, tableName) {
                return runner.executeNonQuery("CREATE TABLE IF NOT EXISTS \"" + tableName + "\" (" + METADATA_FIELD_LIST + ", UNIQUE (SS_Key, Module_SS_Key))");
            }
            Metamodel.innerCreate = innerCreate;
            function verifyColumns(runner) {
                return innerVerifyColumns(runner, METADATA_TABLE_NAME).andThen(function (runner) {
                    return innerVerifyColumns(runner, METADATA_BACKUP_TABLE_NAME);
                });
            }
            Metamodel.verifyColumns = verifyColumns;
            function innerVerifyColumns(runner, tableName) {
                var hasAllColumns = true;
                var qualifiedFieldNames = METADATA_FIELD_INFO.map(function (f) { return "\"ent\".\"" + f.name + "\""; });
                return runner
                    .executeQueryRaw("SELECT " + qualifiedFieldNames.join(", ") + " FROM \"" + tableName + "\" \"ent\" LIMIT 0")
                    .onError(function (err) {
                    hasAllColumns = false;
                })
                    .andThen(function () {
                    return hasAllColumns;
                });
            }
            Metamodel.innerVerifyColumns = innerVerifyColumns;
            function addMissingColumns(runner) {
                return runner
                    .feed(null)
                    .andThenAll(function (_) {
                    return METADATA_FIELD_INFO.map(function (f) { return function (runner) { return addColumnIfNeeded(runner, f.name, f.defaultValue); }; });
                });
            }
            Metamodel.addMissingColumns = addMissingColumns;
            function addColumnIfNeeded(runner, colName, rawDefaultValue) {
                return innerAddColumnIfNeeded(runner, METADATA_TABLE_NAME, colName, rawDefaultValue).andThen(function (runner) {
                    return innerAddColumnIfNeeded(runner, METADATA_BACKUP_TABLE_NAME, colName, rawDefaultValue);
                });
            }
            Metamodel.addColumnIfNeeded = addColumnIfNeeded;
            function innerAddColumnIfNeeded(runner, tableName, colName, rawDefaultValue) {
                var noColumn = false;
                return runner.feed(null).andThenAll(function (_) { return [
                    function (runner) {
                        return runner
                            .executeNonQuery("SELECT \"ent\".\"" + colName + "\" FROM " + tableName + " \"ent\" LIMIT 0")
                            .onError(function (e) {
                            noColumn = true;
                        });
                    },
                    function (runner) {
                        return noColumn
                            ? runner
                                .executeNonQuery("ALTER TABLE " + tableName + " ADD \"" + colName + "\"")
                                .andThen(function (runner) {
                                return rawDefaultValue
                                    ? runner.executeNonQuery("UPDATE " + tableName + " SET \"" + colName + "\" = " + rawDefaultValue)
                                    : runner.feed(null);
                            })
                            : runner.feed(null);
                    },
                ]; });
            }
            function copyMetaInfo(runner, tableName, isRollback) {
                var sourceTable = isRollback ? METADATA_BACKUP_TABLE_NAME : METADATA_TABLE_NAME;
                var targetTable = isRollback ? METADATA_TABLE_NAME : METADATA_BACKUP_TABLE_NAME;
                var continuation = runner
                    .executeNonQuery("DELETE FROM " + targetTable + " WHERE Physical_Table_name = ?", [tableName])
                    .andThen(function (runner) {
                    return runner.executeNonQuery("INSERT INTO " + targetTable + "(" + METADATA_FIELD_LIST + ") SELECT " + METADATA_FIELD_LIST + " FROM " + sourceTable + " WHERE Physical_Table_name = ?", [tableName]);
                });
                if (isRollback) {
                    continuation = continuation.andThen(function (runner) {
                        return runner.executeNonQuery("DELETE FROM " + sourceTable + " WHERE Physical_Table_name = ?", [tableName]);
                    });
                }
                return continuation;
            }
            Metamodel.copyMetaInfo = copyMetaInfo;
            function extractEntityMetadata(info) {
                Logger.trace("Metamodel", "Extracting metadata for table " + info.tableName + " (" + info.name + ")");
                var newExtraInfo = {
                    v: 0,
                    idIsAutoNumber: info.idIsAutoNumber,
                    attrs: {},
                };
                for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
                    var attr = _a[_i];
                    newExtraInfo.attrs[attr.name.toLowerCase()] = extractAttributeMetadata(attr);
                }
                return newExtraInfo;
            }
            Metamodel.extractEntityMetadata = extractEntityMetadata;
            function extractAttributeMetadata(attr) {
                var extraAttrInfo = {
                    type: attr.type,
                };
                if (attr.decimals !== undefined) {
                    extraAttrInfo.decimals = attr.decimals;
                }
                if (attr.length !== undefined) {
                    extraAttrInfo.length = attr.length;
                }
                if (attr.isPrimaryKey) {
                    extraAttrInfo.isPrimaryKey = attr.isPrimaryKey;
                }
                if (attr.isEntityReference) {
                    extraAttrInfo.isEntityReference = attr.isEntityReference;
                }
                return extraAttrInfo;
            }
            function updateEntity(runner, info, moduleKey) {
                var newExtraInfo = extractEntityMetadata(info);
                Logger.trace("Metamodel", "Updating metadata for table " + info.tableName + " (" + info.name + ")");
                var updateArgList = new QueryArgumentsList();
                updateArgList.add("Hash", Interfaces_1.ClientDB.DBDataType.TEXT, info.hash);
                updateArgList.add("Name", Interfaces_1.ClientDB.DBDataType.TEXT, info.name);
                updateArgList.add("Physical_Table_name", Interfaces_1.ClientDB.DBDataType.TEXT, info.tableName);
                updateArgList.add("Extra_Info", Interfaces_1.ClientDB.DBDataType.TEXT, JSON.stringify(newExtraInfo));
                updateArgList.add("Key", Interfaces_1.ClientDB.DBDataType.TEXT, info.key);
                updateArgList.add("ModuleKey", Interfaces_1.ClientDB.DBDataType.TEXT, moduleKey);
                return runner.executeNonQuery("UPDATE " + METADATA_TABLE_NAME + " SET Hash = ?, Name = ?, Physical_Table_name = ?, Extra_Info = ? WHERE SS_Key = ? AND Module_SS_Key = ?", updateArgList.toArray());
            }
            Metamodel.updateEntity = updateEntity;
            function insertEntity(runner, info, moduleKey) {
                var newExtraInfo = extractEntityMetadata(info);
                var insertArgList = new QueryArgumentsList();
                insertArgList.add("Key", Interfaces_1.ClientDB.DBDataType.TEXT, info.key);
                insertArgList.add("ModuleKey", Interfaces_1.ClientDB.DBDataType.TEXT, moduleKey);
                insertArgList.add("Name", Interfaces_1.ClientDB.DBDataType.TEXT, info.name);
                insertArgList.add("TableName", Interfaces_1.ClientDB.DBDataType.TEXT, info.tableName);
                insertArgList.add("Hash", Interfaces_1.ClientDB.DBDataType.TEXT, info.hash);
                insertArgList.add("Extra_Info", Interfaces_1.ClientDB.DBDataType.TEXT, JSON.stringify(newExtraInfo));
                insertArgList.add("Upgrade_Status", Interfaces_1.ClientDB.DBDataType.TEXT, 3);
                return runner.executeNonQuery("INSERT INTO " + METADATA_TABLE_NAME + "(SS_Key, Module_SS_Key, Name, Physical_Table_name, Hash, Extra_Info, Upgrade_Status) VALUES (?, ?, ?, ?, ?, ?, ?)", insertArgList.toArray());
            }
            Metamodel.insertEntity = insertEntity;
        })(Metamodel = Upgrades.Metamodel || (Upgrades.Metamodel = {}));
        function typeUpgradeNeedsValueConversion(from, to) {
            if (from === undefined) {
                return true;
            }
            if (from === to) {
                return false;
            }
            switch (from) {
                case Interfaces_1.ClientDB.DBDataType.BOOLEAN:
                    return to !== Interfaces_1.ClientDB.DBDataType.INTEGER && to !== Interfaces_1.ClientDB.DBDataType.LONGINTEGER;
                case Interfaces_1.ClientDB.DBDataType.INTEGER:
                    return to !== Interfaces_1.ClientDB.DBDataType.LONGINTEGER && to !== Interfaces_1.ClientDB.DBDataType.TEXT;
                case Interfaces_1.ClientDB.DBDataType.LONGINTEGER:
                    return to !== Interfaces_1.ClientDB.DBDataType.TEXT;
                default:
                    return true;
            }
        }
        function needsValueConversion(fromInfo, toInfo) {
            if (typeUpgradeNeedsValueConversion(fromInfo.type, toInfo.type)) {
                return true;
            }
            if (!fromInfo.isEntityReference !== !toInfo.isEntityReference) {
                return true;
            }
            if (fromInfo.length !== undefined) {
                if (fromInfo.decimals !== undefined) {
                    return fromInfo.length - fromInfo.decimals > toInfo.length - toInfo.decimals;
                }
                return fromInfo.length > toInfo.length;
            }
            return false;
        }
        function upgradeDbValue(dbValue, fromInfo, toInfo) {
            if (needsValueConversion(fromInfo, toInfo)) {
                var originalValue = DataConversion_1.LocalStorageConverter.deserializeFromDB(dbValue, fromInfo.type);
                var newModelDataType = DataConversion_1.LocalStorageConverter.convertToModelDataType(toInfo.type);
                var operation = createOperationLabel(dbValue, originalValue, fromInfo.type, newModelDataType);
                if (DataConversion_1.JSConversions.isConvertibleTo(originalValue, newModelDataType)) {
                    var convertedValue = DataConversion_1.JSConversions.convertTo(originalValue, newModelDataType);
                    var dbConvertedValue = DataConversion_1.LocalStorageConverter.serializeToDB(convertedValue, toInfo);
                    validateValueForCreateOrUpdate(dbConvertedValue, toInfo, operation);
                    return dbConvertedValue;
                }
                else {
                    throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to " + operation + ".");
                }
            }
            else {
                return dbValue;
            }
        }
        Upgrades.upgradeDbValue = upgradeDbValue;
        function createOperationLabel(dbValue, originalValue, originalType, newModelDataType) {
            var dbValueToLog = dbValue;
            var originalValueToLog = originalValue;
            var originalTypeLabel = GetDBDataTypeLabel(originalType);
            var newModelDataTypeLabel = DataTypes.DataTypes[newModelDataType];
            if (typeof dbValue === "string" && !!dbValue) {
                dbValueToLog = dbValue.substr(0, 50) + (" (length:" + dbValue.length + ")");
            }
            if (DataTypes.TypeValidations.isText(originalValue)) {
                var val = originalValue;
                originalValueToLog = val.substr(0, 50) + (" (length:" + val.length + ")");
            }
            if (originalValue instanceof DataTypes.BinaryData) {
                var content = originalValue.content;
                originalValueToLog = content.substr(0, 50) + (" (length:" + content.length + ")");
            }
            return "convert databaseValue:'" + dbValueToLog + "'/deserializedValue:'" + originalValueToLog + "' from type " + originalTypeLabel + " to " + newModelDataTypeLabel;
        }
        function getCorrespondingColumnInfo(attrInfo, tableInfo) {
            var attrNameInLowercase = attrInfo.name.toLowerCase();
            var cols = tableInfo.attributes.filter(function (col) { return col.name.toLowerCase() === attrNameInLowercase; });
            if (cols.length === 0) {
                return null;
            }
            else {
                return cols[0];
            }
        }
        function convertRecordAttribute(attrValue, attr, tableInfo, extraInfo) {
            if (tableInfo) {
                var tableAttr = getCorrespondingColumnInfo(attr, tableInfo);
                if (tableAttr !== null) {
                    if (extraInfo && tableAttr.type === Interfaces_1.ClientDB.DBDataType.DATE_TIME) {
                        var extraInfoAttr_1 = extraInfo.attrs[attr.name.toLowerCase()];
                        if (extraInfoAttr_1) {
                            return Upgrades.upgradeDbValue(attrValue, extraInfoAttr_1, attr);
                        }
                    }
                    return Upgrades.upgradeDbValue(attrValue, tableAttr, attr);
                }
            }
            var extraInfoAttr = extraInfo.attrs[attr.name.toLowerCase()];
            if (extraInfoAttr) {
                return Upgrades.upgradeDbValue(attrValue, extraInfoAttr, attr);
            }
            return attrValue;
        }
        function upgradeDbRecord(dbRecord, info, tableInfo, extraInfo) {
            var dbRecordInLowercase = {};
            for (var _i = 0, _a = Object.keys(dbRecord); _i < _a.length; _i++) {
                var prop = _a[_i];
                dbRecordInLowercase[prop.toLowerCase()] = dbRecord[prop];
            }
            fillWithDefaults(dbRecordInLowercase, info);
            var newDbRecord = {};
            for (var _b = 0, _c = info.attributes; _b < _c.length; _b++) {
                var attr = _c[_b];
                try {
                    var attrNameLower = attr.name.toLowerCase();
                    var oldValue = dbRecordInLowercase[attrNameLower];
                    newDbRecord[attrNameLower] = convertRecordAttribute(oldValue, attr, tableInfo, extraInfo);
                }
                catch (error) {
                    throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to upgrade attribute '" + attr.name + "' data type to '" + DataConversion_1.LocalStorageConverter.typeDisplayName(attr.type) + "':\n" + Exceptions_1.getMessage(error));
                }
            }
            return newDbRecord;
        }
        Upgrades.upgradeDbRecord = upgradeDbRecord;
        function requiresFullUpgrade(entityInfo, tableInfo, extraMetadata) {
            var dbIdIsAutoNumber;
            if (tableInfo) {
                dbIdIsAutoNumber = tableInfo.idIsAutoNumber;
            }
            else {
                dbIdIsAutoNumber = extraMetadata.idIsAutoNumber;
            }
            if (dbIdIsAutoNumber !== entityInfo.idIsAutoNumber) {
                return true;
            }
            var attrInfos = getAttributeInfoSummary(entityInfo, tableInfo, extraMetadata);
            return attrInfos.some(function (info) {
                if (!info.entityAttribute) {
                    return true;
                }
                if (!info.dbAttribute && !info.dbMetaAttribute) {
                    return info.entityAttribute.isPrimaryKey;
                }
                return columnDefinitionHasChanged(info.entityAttribute, info.dbAttribute, info.dbMetaAttribute, dbIdIsAutoNumber !== Interfaces_1.ClientDB.AutoNumber.No);
            });
        }
        Upgrades.requiresFullUpgrade = requiresFullUpgrade;
        function columnDefinitionHasChanged(newInfo, dbInfo, dbMetaInfo, idIsAutoNumber) {
            if (idIsAutoNumber === void 0) { idIsAutoNumber = false; }
            if (dbInfo) {
                var metaInfoTypeIsOk = dbMetaInfo === undefined ||
                    dbMetaInfo.type === undefined ||
                    dbMetaInfo.type === newInfo.type;
                return (!metaInfoTypeIsOk ||
                    typeDefinitionHasChanged(newInfo, dbInfo, idIsAutoNumber, dbMetaInfo) ||
                    !dbInfo.isPrimaryKey !== !newInfo.isPrimaryKey);
            }
            else {
                return (typeDefinitionHasChanged(newInfo, dbMetaInfo, idIsAutoNumber) ||
                    !dbMetaInfo.isPrimaryKey !== !newInfo.isPrimaryKey);
            }
        }
        function typeDefinitionHasChanged(newInfo, oldInfo, idIsAutoNumber, extraInfo) {
            if (idIsAutoNumber === void 0) { idIsAutoNumber = false; }
            if (extraInfo === void 0) { extraInfo = null; }
            var changedDbType;
            var infoToUse = oldInfo;
            if (extraInfo && oldInfo.type === Interfaces_1.ClientDB.DBDataType.DATE_TIME) {
                infoToUse = extraInfo;
            }
            if (newInfo.isPrimaryKey && infoToUse.isPrimaryKey && idIsAutoNumber) {
                changedDbType = !((Interfaces_1.ClientDB.DBDataType.INTEGER === newInfo.type || Interfaces_1.ClientDB.DBDataType.LONGINTEGER === newInfo.type) &&
                    (Interfaces_1.ClientDB.DBDataType.INTEGER === infoToUse.type || Interfaces_1.ClientDB.DBDataType.LONGINTEGER === infoToUse.type));
            }
            else {
                changedDbType = newInfo.type !== infoToUse.type;
            }
            return (changedDbType ||
                (infoToUse.type !== Interfaces_1.ClientDB.DBDataType.DECIMAL && infoToUse.length !== newInfo.length) ||
                (infoToUse.type !== Interfaces_1.ClientDB.DBDataType.DECIMAL && infoToUse.decimals !== newInfo.decimals) ||
                (!infoToUse.isEntityReference !== !newInfo.isEntityReference && !newInfo.isPrimaryKey));
        }
        function getAttributeInfoSummary(entityInfo, tableInfo, extraMetadata) {
            var pairedInfo = {};
            for (var _i = 0, _a = entityInfo.attributes; _i < _a.length; _i++) {
                var einfoAttr = _a[_i];
                var attrName = einfoAttr.name.toLowerCase();
                pairedInfo[attrName] = {};
                pairedInfo[attrName].entityAttribute = einfoAttr;
            }
            for (var _b = 0, _c = Object.keys(extraMetadata.attrs); _b < _c.length; _b++) {
                var attr = _c[_b];
                var attrName = attr.toLowerCase();
                pairedInfo[attrName] = pairedInfo[attrName] || {};
                pairedInfo[attrName].dbMetaAttribute = extraMetadata.attrs[attr];
            }
            if (tableInfo) {
                for (var _d = 0, _e = tableInfo.attributes; _d < _e.length; _d++) {
                    var tblInfoAttr = _e[_d];
                    var attrName = tblInfoAttr.name.toLowerCase();
                    pairedInfo[attrName] = pairedInfo[attrName] || {};
                    pairedInfo[attrName].dbAttribute = tblInfoAttr;
                }
            }
            return Object.keys(pairedInfo).map(function (attrName) { return pairedInfo[attrName]; });
        }
    })(Upgrades = exports.Upgrades || (exports.Upgrades = {}));
    var CreateOrUpdateAllMethod;
    (function (CreateOrUpdateAllMethod) {
        CreateOrUpdateAllMethod[CreateOrUpdateAllMethod["Auto"] = 0] = "Auto";
        CreateOrUpdateAllMethod[CreateOrUpdateAllMethod["Single"] = 1] = "Single";
        CreateOrUpdateAllMethod[CreateOrUpdateAllMethod["Bulk"] = 2] = "Bulk";
    })(CreateOrUpdateAllMethod || (CreateOrUpdateAllMethod = {}));
    var EntityIdOutputTypeFactory = new DataTypes.BasicTypeKeyedTypeFactory("Id", "idOut");
    var EntityRecordOutputTypeFactory = new DataTypes.ComplexTypeKeyedTypeFactory("Record", "recordOut");
    var WebSQLStorage = (function () {
        function WebSQLStorage() {
        }
        WebSQLStorage.prototype.getDatabase = function () {
            var _this = this;
            if (this._db) {
                return Promise.resolve(this._db);
            }
            if (!this.dbReadyPromise) {
                this.dbReadyPromise = new Promise(function (resolve) {
                    _this.onDbInit = function () { return resolve(_this._db); };
                });
            }
            return this.dbReadyPromise;
        };
        WebSQLStorage.prototype.trace = function (msg) {
            Logger.trace(this, msg);
        };
        WebSQLStorage.prototype.initDb = function (db) {
            Logger.trace(this, "Setting platform database to '" + (db ? db.name : "none") + "'");
            this._db = db;
            if (this.onDbInit) {
                this.onDbInit();
                this.onDbInit = null;
            }
        };
        WebSQLStorage.prototype.clearDb = function () {
            this._db = null;
        };
        WebSQLStorage.prototype.initModule = function (entitiesInfo, runner, moduleKey) {
            var _this = this;
            return this.recoverBackupTables(runner, entitiesInfo, moduleKey)
                .andThen(function (runner) {
                return entitiesInfo.length === 0
                    ? runner.feed(null)
                    : _this.dropInconsistentTables(runner, entitiesInfo, moduleKey);
            })
                .andThen(function (runner) {
                return _this.backupDeletedTables(runner, entitiesInfo, moduleKey);
            })
                .andThen(function (runner) {
                var argsList = new QueryArgumentsList();
                argsList.add("ModuleKey", Interfaces_1.ClientDB.DBDataType.TEXT, moduleKey);
                return runner.executeQuery("SELECT SS_Key, Hash, Extra_Info FROM OSSYS_ENTITY WHERE Module_SS_Key = ?", function (result) {
                    return {
                        hash: result.Hash,
                        extraInfo: JSON.parse(result.Extra_Info || "{}"),
                        ssKey: result.SS_Key,
                    };
                }, argsList.toArray());
            })
                .andThenAll(function (storedMetadata) {
                return entitiesInfo.map(function (info) {
                    var thisMetadata = storedMetadata.filter(function (m) { return m.ssKey === info.key; });
                    return function (runner) {
                        return _this.createOrUpgradeTable(runner, info, thisMetadata.length === 1 ? thisMetadata[0] : undefined, moduleKey);
                    };
                });
            });
        };
        WebSQLStorage.prototype.initMetamodel = function (runner) {
            return Upgrades.Metamodel.create(runner)
                .andThen(function (runner) { return Upgrades.Metamodel.verifyColumns(runner); })
                .andThen(function (runner, hasAllColumns) {
                if (hasAllColumns) {
                    return;
                }
                return Upgrades.Metamodel.addMissingColumns(runner);
            });
        };
        WebSQLStorage.prototype.createOrUpgradeTable = function (runner, info, result, moduleKey) {
            var _this = this;
            this.trace("Checking the status of table " + info.tableName + " (" + info.name + ")");
            if (!result) {
                result = { hash: null, extraInfo: Upgrades.Metamodel.getDefaultMetaData() };
            }
            var hash = result.hash, extraInfo = result.extraInfo;
            if (!hash) {
                this.trace("Table " + info.tableName + " (" + info.name + ") does not exist and will be created");
                return this.createTable(runner, info, moduleKey).andThen(function (runner) {
                    return Upgrades.Metamodel.insertEntity(runner, info, moduleKey);
                });
            }
            else if (hash !== info.hash) {
                return Database_1.SqlDbIntrospector.introspectTableInfo(runner, info.tableName).andThen(function (runner, tableInfo) {
                    if (Upgrades.requiresFullUpgrade(info, tableInfo, extraInfo)) {
                        _this.trace("Table " + info.tableName + " (" + info.name + ") exists and will be fully upgraded");
                        return _this.recreateTable(runner, info, tableInfo, moduleKey, extraInfo);
                    }
                    else {
                        _this.trace("Table " + info.tableName + " (" + info.name + ") exists and will be incrementally upgraded");
                        return _this.upgradeTable(runner, info, tableInfo, moduleKey, extraInfo);
                    }
                });
            }
            else {
                this.trace("Table " + info.tableName + " (" + info.name + ") exists and is up to date");
                return null;
            }
        };
        WebSQLStorage.prototype.recreateTable = function (runner, info, tableInfo, moduleKey, extraInfo) {
            var _this = this;
            return (runner
                .executeQuery("SELECT * FROM \"" + info.tableName + "\"", function (dbRecord) { return dbRecord; })
                .onError(function (error) {
                _this.trace("Unable to upgrade the definition of entity '" + info.name + "':\n" + Exceptions_1.getMessage(error));
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to upgrade the definition of entity '" + info.name + "':\n" + Exceptions_1.getMessage(error));
            })
                .andThen(function (runner, values) {
                return _this.backupTable(runner, info.tableName, 2)
                    .andThen(function (runner) { return _this.createTable(runner, info, moduleKey); })
                    .andThenAll(function () {
                    return values.map(function (dbRecord) {
                        var newDbRecord = Upgrades.upgradeDbRecord(dbRecord, info, tableInfo, extraInfo);
                        var argList = new QueryArgumentsList(true);
                        for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
                            var attr = _a[_i];
                            argList.add(attr.name, attr.type, newDbRecord[attr.name.toLowerCase()]);
                        }
                        return function (runner) {
                            return runner.executeNonQuery(info.insert.sql, argList.toArray());
                        };
                    });
                });
            })
                .andThen(function (runner) { return Upgrades.Metamodel.updateEntity(runner, info, moduleKey); }));
        };
        WebSQLStorage.prototype.upgradeTable = function (runner, info, tableInfo, moduleKey, extraInfo, hash) {
            var _this = this;
            if (hash === void 0) { hash = null; }
            return runner
                .feed(null)
                .andThenAll(function () {
                var newAttributes = info.attributes.filter(function (attr) {
                    if (tableInfo) {
                        return !tableInfo.attributes.some(function (dbAttr) { return attr.name === dbAttr.name; });
                    }
                    else {
                        return !Object.keys(extraInfo.attrs).some(function (infoAttrName) { return infoAttrName === attr.name.toLowerCase(); });
                    }
                });
                _this.trace("Entity '" + info.name + "' - newAttributes - " + JSON.stringify(newAttributes) + " - hash - " + hash + " - info.hash - " + info.hash);
                return newAttributes.map(function (attribute) {
                    return function (runner) {
                        var cont = runner.executeNonQuery(attribute.addColumn.sql);
                        if (attribute.default !== undefined) {
                            var argsList_1 = new QueryArgumentsList();
                            argsList_1.add("value", attribute.type, attribute.default);
                            cont = cont.andThen(function (runner) {
                                return runner.executeNonQuery("UPDATE \"" + info.tableName + "\" SET \"" + attribute.name + "\" = ?", argsList_1.toArray());
                            });
                        }
                        return cont;
                    };
                });
            })
                .andThen(function (runner) { return Upgrades.Metamodel.updateEntity(runner, info, moduleKey); });
        };
        WebSQLStorage.prototype.switchModule = function (runner, moduleKey) {
            return this.dropBackupTables(runner, moduleKey);
        };
        WebSQLStorage.prototype.recoverBackupTables = function (runner, entitiesInfo, moduleKey) {
            var _this = this;
            return this.doForEachTable(runner, function (tableName) {
                _this.trace("Recovering table " + tableName);
                var filtered = entitiesInfo.filter(function (value) { return value.tableName === tableName; });
                return function (runner) {
                    return _this.recoverBackupTable(runner, tableName, filtered.length === 1 ? filtered[0] : null, moduleKey);
                };
            }, moduleKey, "Upgrade_Status <> " + 0);
        };
        WebSQLStorage.prototype.dropInconsistentTables = function (runner, entitiesInfo, moduleKey) {
            var _this = this;
            return this.doForEachTable(runner, function (tableName) {
                _this.trace("Dropping inconsistent table " + tableName + " (same key, different physical table name)");
                return function (runner) {
                    return _this.dropTableIfExists(runner, tableName).andThen(function (runner) {
                        return runner.executeNonQuery("DELETE FROM OSSYS_ENTITY WHERE upper(Physical_Table_name) = '" + tableName + "'");
                    });
                };
            }, moduleKey, "Upgrade_Status = " +
                0 +
                (entitiesInfo.length === 0
                    ? ""
                    : " AND SS_Key IN (" + entitiesInfo
                        .map(function (info) { return "'" + info.key + "'"; })
                        .join(", ") + ")" +
                        (" AND Physical_Table_name NOT IN (" + entitiesInfo
                            .map(function (info) { return "'" + info.tableName + "'"; })
                            .join(", ") + ")")));
        };
        WebSQLStorage.prototype.dropBackupTables = function (runner, moduleKey) {
            var _this = this;
            return this.doForEachTable(runner, function (tableName) {
                _this.trace("Dropping table " + tableName);
                return function (runner) { return _this.dropBackupTable(runner, tableName); };
            }, moduleKey, "Upgrade_Status <> " + 0);
        };
        WebSQLStorage.prototype.backupDeletedTables = function (runner, entitiesInfo, moduleKey) {
            var _this = this;
            return this.doForEachTable(runner, function (tableName) {
                _this.trace("Backing up old table " + tableName);
                return function (runner) { return _this.backupTable(runner, tableName, 1); };
            }, moduleKey, "Upgrade_Status = " +
                0 +
                (entitiesInfo.length === 0
                    ? ""
                    : " AND Physical_Table_name NOT IN (" + entitiesInfo
                        .map(function (info) { return "'" + info.tableName + "'"; })
                        .join(", ") + ")"));
        };
        WebSQLStorage.prototype.doForEachTable = function (runner, getStatement, moduleKey, additionalSqlFilters) {
            var sql = "SELECT Physical_Table_name as name FROM OSSYS_ENTITY WHERE Module_SS_Key = '" + moduleKey + "'";
            if (additionalSqlFilters) {
                sql += " AND " + additionalSqlFilters;
            }
            return runner
                .executeQuery(sql, function (dbRecord) { return dbRecord.name; })
                .andThenAll(function (tables) {
                var statements = [];
                tables.forEach(function (tableName) {
                    statements.push(getStatement(tableName));
                });
                return statements;
            });
        };
        WebSQLStorage.prototype.dropTableIfExists = function (runner, tableName) {
            return runner.executeNonQuery("DROP TABLE IF EXISTS \"" + tableName + "\"");
        };
        WebSQLStorage.prototype.createTable = function (runner, info, moduleKey) {
            this.trace("createTable '" + info.createTable.sql + "'");
            return runner.executeNonQuery(info.createTable.sql);
        };
        WebSQLStorage.prototype.backupTable = function (runner, tableName, reason) {
            var _this = this;
            this.trace("backupTable '" + tableName + "'");
            return Upgrades.Metamodel.copyMetaInfo(runner, tableName, false)
                .andThen(function (runner) { return _this.dropTableIfExists(runner, _this.getBackupTableName(tableName)); })
                .andThen(function (runner) {
                return _this.renameTableAndSetStatus(runner, tableName, _this.getBackupTableName(tableName), tableName, reason);
            });
        };
        WebSQLStorage.prototype.recoverBackupTable = function (runner, tableName, info, moduleKey) {
            var _this = this;
            var hasBackupTable = true;
            return (this.dropTableIfExists(runner, tableName)
                .andThen(function (runner) {
                return runner.executeScalar("SELECT 1 FROM " + _this.getBackupTableName(tableName));
            })
                .onError(function (error) {
                if (error) {
                    hasBackupTable = false;
                }
            })
                .andThen(function (runner) {
                if (hasBackupTable) {
                    return _this.renameTableAndSetStatus(runner, _this.getBackupTableName(tableName), tableName, tableName, 0);
                }
            })
                .andThen(function (runner) { return Upgrades.Metamodel.copyMetaInfo(runner, tableName, true); }));
        };
        WebSQLStorage.prototype.dropBackupTable = function (runner, tableName) {
            return this.dropTableIfExists(runner, this.getBackupTableName(tableName))
                .andThen(function (runner) {
                return runner.executeScalar("SELECT Upgrade_Status FROM OSSYS_ENTITY WHERE upper(Physical_Table_name) = '" + tableName + "'");
            })
                .andThen(function (runner, upgradeStatus) {
                return runner.executeNonQuery(upgradeStatus === 1
                    ? "DELETE FROM OSSYS_ENTITY WHERE upper(Physical_Table_name) = '" + tableName + "'"
                    : "UPDATE OSSYS_ENTITY SET Upgrade_Status = " + 0 + " WHERE upper(Physical_Table_name) = '" + tableName + "'");
            })
                .andThen(function (runner) {
                return runner.executeNonQuery("DELETE FROM " + exports.BACKUP_TABLE_PREFIX + "OSSYS_ENTITY WHERE Physical_Table_name = ?", [
                    tableName,
                ]);
            });
        };
        WebSQLStorage.prototype.renameTableAndSetStatus = function (runner, currentTableName, newTableName, originalTableName, upgradeStatus) {
            var _this = this;
            this.trace("renameTableAndSetStatus '" + originalTableName + " to " + newTableName + "'");
            return this.renameTable(runner, currentTableName, newTableName).andThen(function (runner) {
                return _this.setTableUpgradeStatus(runner, originalTableName, upgradeStatus);
            });
        };
        WebSQLStorage.prototype.renameTable = function (runner, currentTableName, newTableName) {
            return runner.executeNonQuery("ALTER TABLE \"" + currentTableName + "\" RENAME TO \"" + newTableName + "\"");
        };
        WebSQLStorage.prototype.setTableUpgradeStatus = function (runner, tableName, upgradeStatus) {
            return runner.executeNonQuery("UPDATE OSSYS_ENTITY SET Upgrade_Status = " + upgradeStatus + " WHERE upper(Physical_Table_name) = '" + tableName + "'");
        };
        WebSQLStorage.prototype.getBackupTableName = function (enabledTableName) {
            return exports.BACKUP_TABLE_PREFIX + enabledTableName;
        };
        WebSQLStorage.prototype.executeNonQuery = function (sql, argsList) {
            return this.getDatabase().then(function (db) {
                return db.executeTransaction(function (runner) { return runner.executeNonQuery(sql, argsList && argsList.toArray()); });
            });
        };
        WebSQLStorage.prototype.executeQuery = function (sql, targetListType, readDb, argsList) {
            return this.getDatabase().then(function (db) {
                return db.executeReadTransaction(function (runner) {
                    return runner
                        .executeQueryRaw(sql, argsList && argsList.toArray())
                        .andThen(function (runner, rs) {
                        return DataConversion_1.LocalStorageConverter.from(rs.rows, targetListType, readDb);
                    });
                });
            });
        };
        WebSQLStorage.prototype.rawExecuteQuery = function (sql, conversionFunction, argsList) {
            return this.getDatabase().then(function (db) {
                return db.executeReadTransaction(function (runner) {
                    return runner
                        .executeQueryRaw(sql, argsList && argsList.toArray())
                        .andThen(function (runner, rs) {
                        var result = new Array(rs.rows.length);
                        for (var i = 0; i < rs.rows.length; i++) {
                            var item = rs.rows.item(i);
                            result[i] = conversionFunction(item);
                        }
                        return result;
                    });
                });
            });
        };
        WebSQLStorage.prototype.executeCount = function (sql, argsList) {
            return this.getDatabase().then(function (db) {
                return db.executeReadTransaction(function (runner) {
                    return runner
                        .executeScalar(sql, argsList && argsList.toArray())
                        .andThen(function (runner, dbValue) {
                        return DataConversion_1.LocalStorageConverter.deserializeFromDB(dbValue, Interfaces_1.ClientDB.DBDataType.LONGINTEGER);
                    });
                });
            });
        };
        WebSQLStorage.prototype.rawExecuteScalar = function (sql, argsList) {
            return this.getDatabase().then(function (db) {
                return db.executeReadTransaction(function (runner) {
                    return runner
                        .executeQueryRaw(sql, argsList && argsList.toArray())
                        .andThen(function (runner, rs) {
                        if (rs.rows.length === 0) {
                            return null;
                        }
                        else {
                            return extractScalar(rs.rows.item(0));
                        }
                    });
                });
            });
        };
        WebSQLStorage.prototype.create = function (info, record) {
            var _this = this;
            validateRecordForCreateOrUpdate(info, record, "create");
            return this.getDatabase().then(function (db) {
                return db.executeTransaction(function (runner) {
                    return _this.createInner(runner, info, record, true);
                });
            });
        };
        WebSQLStorage.prototype.createInner = function (runner, info, record, fetchInsertedId) {
            var attrValues = info.insert.getArguments(record);
            return runner
                .executeQueryRaw(info.insert.sql, attrValues.toArray())
                .andThen(function (runner, rs) {
                if (info.getIdAttribute() === null) {
                    return null;
                }
                if (info.idIsAutoNumber === Interfaces_1.ClientDB.AutoNumber.No ||
                    (info.idIsAutoNumber === Interfaces_1.ClientDB.AutoNumber.YesIfEmpty && !info.hasNullId(record))) {
                    fetchInsertedId = false;
                }
                var idType = info.getIdAttribute().type;
                var dataType = DataConversion_1.LocalStorageConverter.convertToModelDataType(idType);
                var result = new (EntityIdOutputTypeFactory.getType(dataType))();
                var id = null;
                if (fetchInsertedId) {
                    id = DataConversion_1.LocalStorageConverter.deserializeFromDB(rs.insertId, idType);
                }
                else {
                    id = info.getIdFromRecord(record);
                }
                result.idOut = id;
                return result;
            });
        };
        WebSQLStorage.prototype.update = function (info, record) {
            validateRecordForCreateOrUpdate(info, record, "update");
            var attrValues = info.update.getArguments(record);
            return this.executeNonQuery(info.update.sql, attrValues);
        };
        WebSQLStorage.prototype.createOrUpdate = function (info, record) {
            var _this = this;
            return this.getDatabase().then(function (db) {
                return db.executeTransaction(function (runner) {
                    return _this.createOrUpdateInner(runner, info, record, true);
                });
            });
        };
        WebSQLStorage.prototype.createOrUpdateInner = function (runner, info, record, fetchInsertedId) {
            validateRecordForCreateOrUpdate(info, record, "create or update");
            if (info.hasNullId(record)) {
                return this.createInner(runner, info, record, true);
            }
            var attrValues = info.upsert.getArguments(record);
            return runner
                .executeQueryRaw(info.upsert.sql, attrValues.toArray())
                .andThen(function (runner, rs) {
                var id = info.getIdFromRecord(record);
                var idType = info.getIdAttribute().type;
                var dataType = DataConversion_1.LocalStorageConverter.convertToModelDataType(idType);
                var result = new (EntityIdOutputTypeFactory.getType(dataType))();
                result.idOut = id;
                return result;
            });
        };
        WebSQLStorage.prototype.createOrUpdateAll = function (info, recordList) {
            var _this = this;
            return this.getDatabase().then(function (db) {
                return db
                    .executeTransaction(function (runner) {
                    if (WebSQLStorage.ForceCreateOrUpdateAllMethod === CreateOrUpdateAllMethod.Bulk ||
                        (WebSQLStorage.ForceCreateOrUpdateAllMethod === CreateOrUpdateAllMethod.Auto &&
                            info.attributes.filter(function (attr) { return attr.type === Interfaces_1.ClientDB.DBDataType.BINARY_DATA; }).length ===
                                0)) {
                        return _this.createOrUpdateAllBulk(runner, info, recordList);
                    }
                    else {
                        return _this.createOrUpdateAllSingle(runner, info, recordList);
                    }
                })
                    .then(ignoreResult);
            });
        };
        WebSQLStorage.prototype.createOrUpdateAllBulk = function (runner, info, recordList) {
            var stuffToDo = [];
            var pushStuff = function (query, parameters) {
                return stuffToDo.push(function (runner) { return runner.executeQueryRaw(query, parameters); });
            };
            var chunkSize = Math.floor(WebSQLStorage.MaxQueryParameters / info.attributes.length);
            if (chunkSize === 0) {
                return this.createOrUpdateAllSingle(runner, info, recordList);
            }
            var chunkCount = Math.ceil(recordList.length / chunkSize);
            for (var i = 0; i < chunkCount; i++) {
                var parameters = [];
                var recordCount = 0;
                while (recordCount < chunkSize) {
                    var idx = i * chunkSize + recordCount;
                    if (idx === recordList.length) {
                        break;
                    }
                    var record = recordList.getItem(idx);
                    validateRecordForCreateOrUpdate(info, record, "create or update");
                    parameters = parameters.concat(info.upsert.getArguments(record).toArray());
                    recordCount++;
                }
                var query = info.upsert.getBulkSql(recordCount);
                pushStuff(query, parameters);
            }
            return runner.feed(null).andThenAll(function (runner) { return stuffToDo; });
        };
        WebSQLStorage.prototype.createOrUpdateAllSingle = function (runner, info, recordList) {
            var _this = this;
            var stuffToDo = [];
            var pushStuff = function (record) {
                return stuffToDo.push(function (runner) { return _this.createOrUpdateInner(runner, info, record, false); });
            };
            for (var i = 0; i < recordList.length; i++) {
                var record = recordList.getItem(i);
                pushStuff(record);
            }
            return runner.feed(null).andThenAll(function (runner) { return stuffToDo; });
        };
        WebSQLStorage.prototype.get = function (info, id) {
            var attr = info.getIdAttribute();
            var argsList = new QueryArgumentsList();
            argsList.add(attr.name, attr.type, id);
            return this.rawExecuteQuery(info.select.sql, info.dbRecordToRecord, argsList).then(function (values) {
                if (values.length === 0) {
                    throw new Exceptions_1.Exceptions.DataBaseException("", info.name + " with id " + id + " was not found");
                }
                else {
                    var result = new (EntityRecordOutputTypeFactory.getType(values[0].constructor))();
                    result.recordOut = values[0];
                    return result;
                }
            });
        };
        WebSQLStorage.prototype.delete = function (info, id) {
            var attr = info.getIdAttribute();
            var argsList = new QueryArgumentsList();
            argsList.add(attr.name, attr.type, id);
            return this.executeNonQuery(info.delete.sql, argsList);
        };
        WebSQLStorage.prototype.deleteAll = function (info) {
            return this.executeNonQuery(info.deleteAll.sql);
        };
        WebSQLStorage.prototype.getBinary = function (info, attrName, id) {
            var _this = this;
            var idAttr = info.getIdAttribute();
            var idName = idAttr.name, idType = idAttr.type;
            var sql = "SELECT \"" + attrName + "\" FROM \"" + info.tableName + "\" WHERE \"" + idName + "\" = ?";
            var argsList = new QueryArgumentsList();
            argsList.add(idName, idType, id);
            return DataConversion_1.LocalStorageConverter.deserializeLazyBinaryFromDB(function () {
                return _this.getDatabase().then(function (db) {
                    return db.executeReadTransaction(function (runner) {
                        return runner.executeScalar(sql, argsList.toArray());
                    });
                });
            });
        };
        WebSQLStorage.prototype.replaceEntityReferencesInOrderBy = function (paramValue, entityNames, entityAliases) {
            var _this = this;
            var ret = null;
            var mc = null;
            var m = null;
            paramValue = paramValue.trim();
            mc = RegExpHelper.matches(paramValue, '(^|\\s|\\.)(\\[|"|)(ossys_|osltm_|oslog_|osevt_|osusr_|osext_)', true);
            if (mc.length > 0) {
                m = mc[0];
                throw new Exceptions_1.Exceptions.DataBaseException("", "'" + (m.groups[2] + m.groups[3]) + "' found in 'Order By' parameter is a reserved prefix");
            }
            if (paramValue !== "") {
                mc = RegExpHelper.matches(paramValue, "((((\\{\\w+\\})|(\\w+)).)?((\\[\\w+\\])|(\\w+))(( )+(desc|asc))?)(( )*,( )*(((\\{\\w+\\})|(\\w+)).)?((\\[\\w+\\])|(\\w+))(( )+(desc|asc))?)*", true);
                if (mc.length !== 1 || mc[0].value !== paramValue) {
                    throw new Exceptions_1.Exceptions.DataBaseException("", "Invalid syntax in 'Order By' parameter.");
                }
            }
            var meReplaceEntityName = function (match) {
                return _this.replaceEntityNameInOrderBy(match, entityNames, entityAliases);
            };
            var meReplaceAttributeName = function (match) {
                return _this.replaceAttributeName(match);
            };
            ret = RegExpHelper.replace(paramValue, "(\\{\\w+\\}|\\w+\\.)", false, meReplaceEntityName);
            ret = RegExpHelper.replace(ret, "(\\[\\w+\\])", false, meReplaceAttributeName);
            return ret;
        };
        WebSQLStorage.prototype.replaceEntityNameInOrderBy = function (m, entityNames, entityAliases) {
            var result = "";
            var entityName = this.getEntityNameFromMatch(m);
            var found = false;
            for (var i = 0; i < entityNames.length; i++) {
                if (entityNames[i].toLowerCase() === entityName.toLowerCase()) {
                    found = true;
                    result = '"' + entityAliases[i] + '"';
                    break;
                }
            }
            if (!found) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "'" + entityName + "' found in 'Order By' parameter is an invalid Entity");
            }
            if (m.value.charAt(m.value.length - 1) === ".") {
                return result + ".";
            }
            else {
                return result;
            }
        };
        WebSQLStorage.prototype.replaceAttributeName = function (m) {
            var result = m.value.substr(1, m.value.length - 2);
            return !result
                ? ""
                : (result.charAt(0) === '"' ? "" : '"') + result + (result.charAt(result.length - 1) === '"' ? "" : '"');
        };
        WebSQLStorage.prototype.getEntityNameFromMatch = function (m) {
            if (m.value.charAt(m.value.length - 1) === ".") {
                return m.value.substr(0, m.value.length - 1);
            }
            else {
                return m.value.substr(1, m.value.length - 2);
            }
        };
        WebSQLStorage.prototype.getOrderByColumnsWithoutDuplicates = function (orderByColumns) {
            return this.filterDuplicateOrderByColumns(orderByColumns).join(", ");
        };
        WebSQLStorage.prototype.filterDuplicateOrderByColumns = function (orderByColumns) {
            var result = new Array();
            var usedColumns = {};
            orderByColumns.forEach(function (col) {
                var trimmed = col.trim();
                if (trimmed !== "") {
                    var invariant = trimmed
                        .replace(new RegExp("\b((ASC)|(DESC))$", "im"), "")
                        .replace('"', "")
                        .replace("[", "")
                        .replace("]", "")
                        .trim()
                        .toLowerCase();
                    if (usedColumns[invariant] !== true) {
                        result.push(trimmed);
                        usedColumns[invariant] = true;
                    }
                }
            });
            return result;
        };
        WebSQLStorage.MaxQueryParameters = 500;
        WebSQLStorage.ForceCreateOrUpdateAllMethod = CreateOrUpdateAllMethod.Auto;
        return WebSQLStorage;
    }());
    exports.WebSQLStorage = WebSQLStorage;
    exports.webSQLStorageInstance = new WebSQLStorage();
    var Entity = (function () {
        function Entity(storage, info, moduleKey) {
            var _this = this;
            this.storage = storage;
            this.info = info;
            this.moduleKey = moduleKey;
            this.getBinary = function (attrName, id, valueMaybe) {
                if (valueMaybe.hasContent()) {
                    return valueMaybe;
                }
                return _this.storage.getBinary(_this.info, attrName, id);
            };
        }
        Entity.prototype.getStorage = function () {
            return this.storage;
        };
        Entity.prototype.getInfo = function () {
            return this.info;
        };
        Entity.prototype.create = function (source) {
            return this.storage.create(this.info, source);
        };
        Entity.prototype.createOrUpdate = function (source) {
            return this.storage.createOrUpdate(this.info, source);
        };
        Entity.prototype.createOrUpdateAll = function (sourceList) {
            return this.storage.createOrUpdateAll(this.info, sourceList);
        };
        Entity.prototype.update = function (source) {
            return this.storage.update(this.info, source);
        };
        Entity.prototype.get = function (id) {
            return this.storage.get(this.info, id);
        };
        Entity.prototype.delete = function (id) {
            return this.storage.delete(this.info, id);
        };
        Entity.prototype.deleteAll = function () {
            return this.storage.deleteAll(this.info);
        };
        return Entity;
    }());
    exports.Entity = Entity;
    function validateRecordForCreateOrUpdate(info, record, operation) {
        var values = info.getAllAttributesFromRecord(record).toArray();
        for (var i = 0; i < info.attributes.length; i++) {
            var attr = info.attributes[i];
            validateValueForCreateOrUpdate(values[i], attr, operation + " '" + info.name + "." + attr.name + "'");
        }
    }
    function validateValueForCreateOrUpdate(dbValue, typeInfo, operation) {
        if (typeInfo.type === Interfaces_1.ClientDB.DBDataType.TEXT) {
            if (dbValue === null) {
                return;
            }
            var attrValue = dbValue;
            var lengthDiff = attrValue.length - typeInfo.length;
            if (lengthDiff > 0) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to " + operation + " because it exceeds the maximum allowed length by " + lengthDiff + " characters.");
            }
        }
        else if (typeInfo.type === Interfaces_1.ClientDB.DBDataType.DECIMAL) {
            var attrValue = dbValue;
            var lengthDiff = attrValue.split(".")[0].length - (typeInfo.length - typeInfo.decimals);
            if (lengthDiff > 0) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to " + operation + " because it exceeds the maximum allowed length by " + lengthDiff + " characters.");
            }
        }
    }
    function GetDBDataTypeLabel(dbDataType) {
        switch (dbDataType) {
            case Interfaces_1.ClientDB.DBDataType.TEXT:
                return "Text";
            case Interfaces_1.ClientDB.DBDataType.BINARY_DATA:
                return "Binary Data";
            case Interfaces_1.ClientDB.DBDataType.BOOLEAN:
                return "Boolean";
            case Interfaces_1.ClientDB.DBDataType.INTEGER:
                return "Integer";
            case Interfaces_1.ClientDB.DBDataType.LONGINTEGER:
                return "Long Integer";
            case Interfaces_1.ClientDB.DBDataType.DECIMAL:
                return "Decimal";
            case Interfaces_1.ClientDB.DBDataType.DATE_TIME:
                return "DateTime";
            case Interfaces_1.ClientDB.DBDataType.DATE:
                return "Date";
            case Interfaces_1.ClientDB.DBDataType.TIME:
                return "Time";
            default:
                return "Unknown";
        }
    }
    var QueryArgumentsList = (function () {
        function QueryArgumentsList(skipConversion) {
            this.skipConversion = skipConversion;
            this.argumentList = [];
            this.existingArguments = {};
        }
        QueryArgumentsList.prototype.add = function (argName, argType, argValue, length, decimals, isEntityReference) {
            if (this.existingArguments[argName]) {
                return;
            }
            this.existingArguments[argName] = true;
            if (argValue === undefined) {
                this.argumentList.push(null);
            }
            else {
                var dbValue = void 0;
                if (this.skipConversion) {
                    dbValue = argValue;
                }
                else {
                    dbValue = DataConversion_1.LocalStorageConverter.serializeToDB(argValue, {
                        type: argType,
                        length: length,
                        decimals: decimals,
                        isEntityReference: isEntityReference,
                    });
                }
                this.argumentList.push(dbValue);
            }
        };
        QueryArgumentsList.prototype.toArray = function () {
            return this.argumentList;
        };
        return QueryArgumentsList;
    }());
    exports.QueryArgumentsList = QueryArgumentsList;
});
//# sourceMappingURL=Entities.js.map;
